import React from 'react';
import { ShieldCheck, ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-navy text-cream overflow-hidden pt-20 pb-24 lg:pt-32 lg:pb-40" data-id="element-44">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-45">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-navy-light opacity-30 blur-3xl" data-id="element-46"></div>
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-gold opacity-10 blur-3xl" data-id="element-47"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-48">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-49">
          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-50">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-navy-light border border-gold/30 text-gold text-sm font-medium mb-8" data-id="element-51">
              <ShieldCheck size={18} data-id="element-52" />
              <span data-id="element-53">Blindaje de Liquidez en 24 Horas</span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-white" data-id="element-54">
              El Arca de Efectivo
            </h1>

            <h2 className="text-xl md:text-2xl text-cream-dark font-body font-light leading-relaxed mb-10 max-w-2xl mx-auto lg:mx-0" data-id="element-55">
              Cómo construir un fondo de emergencia de{' '}
              <span className="text-gold font-semibold" data-id="element-56">$1,000 en 30 días</span>{' '}
              (incluso si hoy vives al límite y tu cuenta está en cero).
            </h2>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4" data-id="element-57">
              <a href="#pricing-action" onClick={e => {
              e.preventDefault();
              document.getElementById('pricing-action')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            }} className="w-full sm:w-auto px-8 py-4 bg-gold hover:bg-gold-light text-navy-dark font-bold rounded-lg transition-all duration-300 flex items-center justify-center gap-2 animate-pulse-gold transform hover:-translate-y-1 text-[20px] cursor-pointer" data-id="element-58">
                QUIERO CONSTRUIR MI ARCA
              </a>
            </div>
          </div>

          {/* Product Image */}
          <div className="flex-1 w-full max-w-lg lg:max-w-none relative" data-id="element-59">
            <div className="relative w-full aspect-square md:aspect-[4/3] lg:aspect-square flex items-center justify-center" data-id="element-60">
              {/* Glow behind image */}
              <div className="absolute inset-0 bg-gold/20 rounded-full blur-3xl animate-pulse" data-id="element-61"></div>
              <img src="https://cdn.magicpatterns.com/uploads/p5SvmXNeJEzvov96TrEJwk/Mockup_E-book_Nº_4-1.png" alt="El Arca de Efectivo - Mockup del libro y aplicación" className="relative z-10 w-full h-auto object-contain animate-float drop-shadow-2xl" data-id="element-62" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}